import { InstructorDashboardComponent } from './instructor-dashboard/instructor-dashboard.component';
import { extract } from '@app/core/i18n/i18n.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: 'instructor', component: InstructorDashboardComponent, data: { title: extract('Referral') } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReferralDashboardRoutingModule {}
